const tempSpaceChar = 'SPACETOREMOVE';

const hitResultMap = {
  HIT: 'Hit',
  DOUBLE: 'Double',
  TRIPLE: 'Triple',
  HOME_RUN: 'Home Run',
  BASE_ON_BALLS: 'Walk',
  STRIKEOUT: 'Strikeout',
  EXTRA_BASE_HIT: 'Double,Triple,Home Run',
  HIT_BATSMEN: 'Hit By Pitch'
};

const hitResultFormatter = {
  'Hit': '"Hit"',
  'Double': '"Double"',
  'Triple': '"Triple"',
  'Home Run': `"Home${tempSpaceChar}Run"`,
  'Walk': '"Walk"',
  'Strikeout': '"Strikeout"',
  'Double,Triple,Home Run': `"Double","Triple","Home${tempSpaceChar}Run"`,
  'Hit By Pitch': `"Hit${tempSpaceChar}By${tempSpaceChar}Pitch"`
};

const statsApiHitResultConversions = {
  'hits': hitResultMap.HIT,
  'doubles': hitResultMap.DOUBLE,
  'triples': hitResultMap.TRIPLE,
  'homeRuns': hitResultMap.HOME_RUN,
  'baseOnBalls': hitResultMap.BASE_ON_BALLS,
  'strikeOuts': hitResultMap.STRIKEOUT,
  'extraBaseHits': hitResultMap.EXTRA_BASE_HIT,
  'hitByPitch': hitResultMap.HIT_BATSMEN,
  'hitBatsmen': hitResultMap.HIT_BATSMEN
};

const descriptionHitResultConversions = {
  'H (Batting)': hitResultMap.HIT,
  '2B (Batting)': hitResultMap.DOUBLE,
  '3B (Batting)': hitResultMap.TRIPLE,
  'HR (Batting)': hitResultMap.HOME_RUN,
  'BB (Batting)': hitResultMap.BASE_ON_BALLS,
  'SO (Batting)': hitResultMap.STRIKEOUT,
  'XBH (Batting)': hitResultMap.EXTRA_BASE_HIT,
  'HBP (Batting)': hitResultMap.HIT_BATSMEN,
  'H (Pitching)': hitResultMap.HIT,
  'HR (Pitching)': hitResultMap.HOME_RUN,
  'HB (Pitching)': hitResultMap.HIT_BATSMEN,
  'BB (Pitching)': hitResultMap.BASE_ON_BALLS,
  'SO (Pitching)': hitResultMap.STRIKEOUT
};

// Returns a hit result after comparing it against popular alternative formats
const getHitResult = (val = '') => {
  return hitResultFormatter[hitResultMap[val] || statsApiHitResultConversions[val] || descriptionHitResultConversions[val]];
};

module.exports = {
  hitResultMap,
  getHitResult,
  statsApiHitResultConversions,
  tempSpaceChar
};
